import { render, staticRenderFns } from "./OtherConsiderations.vue?vue&type=template&id=45cd8c18&scoped=true&"
import script from "./OtherConsiderations.vue?vue&type=script&lang=js&"
export * from "./OtherConsiderations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd8c18",
  null
  
)

export default component.exports